import axios from "axios";

/** Site root, e.g. https://nosazfilmclub.ir/ */
export const SITE_URL = (
  process.env.REACT_APP_SITE_URL || "https://nosazfilmclub.ir/"
).replace(/\/?$/, "/");

export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || `${SITE_URL}api/v1/`;

const TOKEN_KEY = "token";

export const readToken = () => {
  try {
    return window.localStorage.getItem(TOKEN_KEY);
  } catch {
    return null;
  }
};

export const writeToken = (token) => {
  try {
    if (token) window.localStorage.setItem(TOKEN_KEY, token);
    else window.localStorage.removeItem(TOKEN_KEY);
  } catch {
    /* storage blocked (private mode) — session stays in memory only */
  }
};

const attachToken = (config) => {
  const token = readToken();
  if (token) config.headers.Authorization = `Token ${token}`;
  return config;
};

/**
 * Main API client. The token interceptor replaces the 17 places that used to
 * read localStorage and hand-build an Authorization header per request.
 */
const client = axios.create({
  baseURL: API_BASE_URL,
  headers: { "Content-Type": "application/json" },
});
client.interceptors.request.use(attachToken);

/** Payment endpoints live at /payment/, outside the /api/v1/ prefix. */
export const paymentClient = axios.create({
  baseURL: `${SITE_URL}payment/`,
  headers: { "Content-Type": "application/json" },
});
paymentClient.interceptors.request.use(attachToken);

// AuthContext registers this so an expired token clears the session once
// rather than every caller special-casing 401.
let onUnauthorized = null;
export const setUnauthorizedHandler = (handler) => {
  onUnauthorized = handler;
};

client.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && readToken()) onUnauthorized?.();
    return Promise.reject(error);
  }
);

export default client;
